'use es6';

export const HORIZONTAL = 'horizontal';
export const VERTICAL = 'vertical';